import React, {memo} from 'react';

import {find} from 'lodash';

import {gt} from 'app/utils/i18n';

type Props = {
  filterValue: string | number;
  onChange: (val: any) => void;
  options: Array<{
    text: string;
    value: any;
  }>;
  defaultValue?: any;
  className?: string;
};

export const SelectTypeFilter = memo<Props>(
  ({filterValue, onChange, options, defaultValue, ...other}: Props) => {
    let value = filterValue;
    let isUnavailable = false;

    if (
      filterValue !== '' &&
      find(options, {
        value: filterValue,
      }) === undefined
    ) {
      value = 'sp-unavailable-sentinel';
      isUnavailable = true;
    }

    return (
      <select
        {...other}
        value={value}
        onChange={(e: any) => onChange(e.target.value)}
      >
        {defaultValue ? (
          <option key="" value="">
            {defaultValue}
          </option>
        ) : (
          ''
        )}
        {isUnavailable ? (
          <option key={value} value={value}>
            {gt('Unavailable')}
          </option>
        ) : null}
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.text}
          </option>
        ))}
      </select>
    );
  }
);
